(function () {
  var toggle = document.getElementById('theme-mode-toggle');
  if (!toggle) return;

  function isDark() {
    return document.documentElement.getAttribute('data-color-mode') === 'dark';
  }

  function updateState() {
    toggle.setAttribute('aria-pressed', String(isDark()));
  }

  toggle.addEventListener('click', function () {
    var next = isDark() ? 'light' : 'dark';
    document.documentElement.setAttribute('data-color-mode', next);
    try {
      localStorage.setItem('zeptigo-color-mode', next);
    } catch (e) {
      // Ignore storage errors (e.g. private browsing).
    }
    updateState();
  });

  updateState();
})();
